export var injectUrlsData = function (_a) {
    var urlsData = _a.urlsData, windowUrlsPath = _a.windowUrlsPath;
    var funcFromText = new Function(urlsData);
    funcFromText();
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //@ts-ignore
    window.cachedWindowEnvs.set(windowUrlsPath, urlsData);
};
